import { OnlineDemoModalPageModule } from './../pages/online-demo-modal/online-demo-modal.module';
import { APIDocsPagePageModule } from "../pages/api-docs/api-docs.module";
import { AdminUsersDetailPageModule } from "../pages/admin-users-detail/admin-users-detail.module";
import { AdminUsersPageModule } from "../pages/admin-users/admin-users.module";
import { BrowserModule } from '@angular/platform-browser';
import { DevBreadcrumbsComponentModule } from '../components/dev-breadcrumbs/dev-breadcrumbs.module';
import { DevHeaderComponentModule } from '../components/dev-header/dev-header.module';
import { DevJumbotronComponentModule } from "../components/dev-jumbotron/dev-jumbotron.module";
import { DevWrapperComponentModule } from "../components/dev-wrapper/dev-wrapper.module";
import { DeveloperProvider } from './../providers/developers';
import { ErrorHandler, NgModule } from '@angular/core';
import { ExtensionsPageModule } from "../pages/extensions/extensions.module";
import { FlxCommonsModule } from '@questrade/flx-commons';
import { FlxDeveloperPortal } from './app.component';
import { FlxDoclistComponentModule } from '../components/flx-doclist/flx-doclist.module';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import { HttpService } from './../providers/http-service';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { LoadingProvider } from './../providers/loading';
import { LoginPageModule } from "../pages/login/login.module";
import { Network } from '@ionic-native/network';
import { PermissionRequestModule } from "../pages/permission-request/permission-request.module";
import { SdkJavascriptPageModule } from "../pages/sdk/sdk-javascript/sdk-javascript.module";
import { SandboxPageModule } from "../pages/sandbox/sandbox.module";
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { ToastProvider } from './../providers/toast';
import { RecaptchaModule } from 'ng-recaptcha';


@NgModule({
  declarations: [
    FlxDeveloperPortal
  ],
  imports: [
    APIDocsPagePageModule,
    AdminUsersDetailPageModule,
    AdminUsersPageModule,
    BrowserModule,
    DevBreadcrumbsComponentModule,
    DevHeaderComponentModule,
    DevJumbotronComponentModule,
    DevWrapperComponentModule,
    ExtensionsPageModule,
    FlxCommonsModule,
    FlxDoclistComponentModule,
    HttpModule,
    IonicModule.forRoot(FlxDeveloperPortal),
    LoginPageModule,
    OnlineDemoModalPageModule,
    PermissionRequestModule,
    SandboxPageModule,
    SdkJavascriptPageModule,
    RecaptchaModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    FlxDeveloperPortal
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Network,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    {
      provide: HttpService,
      useFactory: httpService,
      deps: [XHRBackend, RequestOptions]
    },
    HttpService,
    DeveloperProvider,
    LoadingProvider,
    ToastProvider,
    InAppBrowser
  ]
})
export class AppModule { }
export function httpService(backend: XHRBackend, options: RequestOptions) {
  return new HttpService(backend, options);
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts